import Filter from "../../components/Filter";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";
import TeamCards from "../TeamCards";


function Myteamskills (){
    return(
        <>
        
        <Dummylayout/>
        <TeamCards/>
   
     
        </>

    );

   
}
export default Myteamskills;